<!--
  @Description 问题汇总导入
  @Date 2021-12-26
  @Author liushuo
  1.导入数据，不包括问题说明；导入时立刻进行关联，若未关联到则提示
  2.点击确认后，可以直接添加进主表（未关联到的也可以导入）
  3.导入后主表点击保存
  4.保存后才可以批量输入问题说明（保存后才有id）
-->
<template>
  <vxe-modal
    v-model="isShow"
    title="问题汇总导入"
    width="80%"
    height="80%"
    @show="showWindows"
    mask-closable
    destroy-on-close
  >
    <vxe-toolbar>
      <template v-slot:buttons>
        <div>
          <input
            type="file"
            ref="uploadExcel"
            v-show="false"
            id="open"
            accept=".xls, .xlsx"
            @change="readExcel"
            v-if="resetExcel"
          />
          <el-input v-model="path" readonly size="mini" class="path-box"></el-input>
          <el-button @click="importExcel" type="primary" size="mini">选择文件</el-button>
          <el-button @click="handleSave" type="primary" size="mini">确认</el-button>
          <el-button @click="exportModule" type="primary" size="mini">导出模板</el-button>
        </div>
        <span>
          导入格式为：
          模块、页面、问题内容、紧急、系统版本、文档编号、类型、提出人、需求调研人、提出日期、截止日期、前端设计人、后端设计人、前端研发、后端研发、技术测试、业务测试
        </span>
        <br />
        <span style="color: red">注意！如果有包含日期的列，请在excel中将此列的数据开头都加入一个单引号</span>
      </template>
    </vxe-toolbar>
    <div class="grid-box">
      <vxe-grid
        ref="xTable"
        highlight-hover-row
        highlight-current-row
        :data="tableData"
        keep-source
        resizable
        size="mini"
        :column-config="{ minWidth: '80px' }"
        :height="tableHeight"
        :cell-class-name="cellClassName"
        :edit-rules="validRules"
        :edit-config="{
          trigger: 'dblclick',
          mode: 'cell',
          activeMethod: activeMethod
        }"
        :keyboard-config="{
          isArrow: true,
          isEnter: true,
          isTab: true,
          enterToTab: true,
          isClip: true,
          isEdit: true,
          editMethod: editMethod
        }"
        :columns="gridColumns"
      >
      </vxe-grid>
    </div>
  </vxe-modal>
</template>

<script>
import { MessageBox } from 'element-ui'
export default {
  props: {
    parentObj: Object
  },
  data() {
    return {
      // 列头
      gridColumns: [],
      // 是否显示
      isShow: false,
      menuArgs: '',
      tableData: [],
      // 验证规则
      validRules: {},
      // 验证错误
      errIndex: [],
      path: '',
      resetExcel: true,
      // 区域数据
      areaList: []
    }
  },
  created() {
    this.InitColumn()
  },
  mounted() {},
  methods: {
    showWindows() {
      this.setRules()
      // 清空表格数据
      this.tableData = []
      // 清空文件名
      this.path = ''
    },
    // 初始化列头
    InitColumn() {
      let that = this
      that.gridColumns = [
        {
          type: 'seq',
          width: '50',
          className: 'seqErrorVaildClass',
          slots: {
            default: ({ row }) => {
              if (row.ifRepeat) {
                return [
                  <el-tooltip class='tooltipItem' effect='light' content={row.repeatText} placement='right'>
                    <div style='width: 100%; height: 100%'>
                      <span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>
                    </div>
                  </el-tooltip>
                ]
              } else {
                return [<span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>]
              }
            }
          }
        },
        {
          field: 'delete',
          title: '删除',
          visible: this.$parent.specialAuthority.super,
          width: '50',
          align: 'center',
          slots: {
            default: ({ row }) => {
              return [
                <i
                  id='vxeDelete'
                  class='el-icon-delete-solid'
                  onClick={() => {
                    this.removeRowForTableAndData(row, this.$refs.xTable, this.$data)
                  }}
                ></i>
              ]
            }
          }
        },
        {
          title: '模块',
          width: 50,
          field: 'groupName'
        },
        {
          title: '页面',
          width: 80,
          field: 'vuePath'
        },
        {
          title: '问题内容',
          minWidth: 200,
          field: 'content'
        },
        {
          title: '紧急',
          width: 40,
          field: 'isPriority'
        },
        {
          title: '系统版本',
          width: 60,
          field: 'productionVersion'
        },
        {
          title: '文档编号',
          width: 50,
          field: 'docNumber'
        },
        {
          title: '类型',
          width: 35,
          field: 'type'
        },
        {
          title: '提出人',
          width: 60,
          field: 'createtor'
        },
        // {
        //   title: '调研人', width: 60, field: 'research',
        // },
        {
          title: '提出日期',
          width: 85,
          field: 'createDate'
        },
        {
          title: '截止日期',
          width: 85,
          field: 'dueDate'
        },
        {
          title: '前端设计人',
          width: 70,
          field: 'frontDesigners'
        },
        {
          title: '后端设计人',
          width: 70,
          field: 'backDesigners'
        },
        {
          title: '前端研发',
          width: 70,
          field: 'frontEngineer'
        },
        {
          title: '后端研发',
          width: 70,
          field: 'backEngineer'
        },
        // {
        //   title: '前端工作量', width: 80, field: 'FrontWorkTime',
        // },
        // {
        //   title: '后端工作量', width: 80, field: 'BackWorkTime',
        // },
        {
          title: '技术测试',
          width: 70,
          field: 'techTester'
        },
        {
          title: '业务测试',
          width: 70,
          field: 'businessTester'
        }
      ]
    },
    // table 点击删除列，同时删除data中的数据
    removeRowForTableAndData(row, table) {
      MessageBox.confirm('确定要删除本行吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          table.remove(row)
          // 删除 tableData 中的数据
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i]._XID === row._XID) {
              this.tableData.splice(i, 1)
              break
            }
          }
        })
        .catch(() => {})
    },
    setRules() {
      const that = this
      that.validRules = {
        // 前端
        frontEngineer: [{ validator: this.validatePersonFront, trigger: 'change' }],
        // 后端
        backEngineer: [{ validator: this.validatePersonBack, trigger: 'change' }],
        // 技术测试
        techTester: [{ validator: this.validatePersonTech, trigger: 'change' }],
        // 业务测试
        businessTester: [{ validator: this.validatePersonBus, trigger: 'change' }]
      }
    },
    // 验证
    async validEnter() {
      let flag = true
      this.errIndex = []

      // 校验重复行（优化方法一）
      const isAllCheck = true
      const errMap = await this.$refs.xTable.fullValidate(isAllCheck).catch(errMap => errMap)
      if (errMap) {
        Object.values(errMap).forEach(errList => {
          errList.forEach(params => {
            let { row, columnIndex, rules } = params
            rules.forEach(() => {
              this.errIndex.push({
                _XID: row._XID,
                columnIndex: columnIndex
              })
            })
          })
        })
        if (this.errIndex.length > 0) {
          flag = false
        }
      }
      if (!flag) {
        this.$message.error('验证失败,请核对数据')
      }
      return flag
    },

    // 转换字符串
    transString(str) {
      if (str) {
        return str + ''
      }
    },
    importExcel() {
      this.resetExcel = false
      this.$nextTick(() => {
        this.resetExcel = true
      })
      this.$refs.uploadExcel.click()
    },
    // 导入excel
    readExcel(evnt) {
      let files = evnt.target.files
      if (files.length === 0) {
        return
      }
      this.path = files[0].name
      let fileReader = new FileReader()
      fileReader.onload = ev => {
        let data = ev.target.result
        let workbook = this.XLSX.read(data, { type: 'binary' })
        // 取第一张表
        const wsname = workbook.SheetNames[0]
        let ws = this.XLSX.utils.sheet_to_json(workbook.Sheets[wsname])
        let str = JSON.stringify(ws)
        str = str.replace(/（/g, '(')
        str = str.replace(/）/g, ')')
        ws = JSON.parse(str)

        this.tableData = []
        // 解析数据
        ws.forEach((value, index, ws) => {
          // 这里需要让tableData先push，才会有 _XID 供后续判断
          this.tableData.push({
            groupName: this.transString(ws[index]['模块']),
            vuePath: this.transString(ws[index]['页面']),
            content: this.transString(ws[index]['问题内容']),
            isPriority: this.transString(ws[index]['紧急']),
            productionVersion: this.transString(ws[index]['系统版本']),
            docNumber: this.transString(ws[index]['文档编号']),
            type: this.transString(ws[index]['类型']),
            createtor: this.transString(ws[index]['提出人']),
            // research: this.transString(ws[index]['调研人']),
            createDate: this.transString(ws[index]['提出日期']),
            dueDate: this.transString(ws[index]['截止日期']),
            frontDesigners: this.transString(ws[index]['前端设计人']),
            backDesigners: this.transString(ws[index]['后端设计人']),
            frontEngineer: this.transString(ws[index]['前端研发']),
            backEngineer: this.transString(ws[index]['后端研发']),
            techTester: this.transString(ws[index]['技术测试']),
            businessTester: this.transString(ws[index]['业务测试']),
            menuArgs: this.productType
          })
        })
        // 导入数据后，对数据和模块菜单进行匹配
        this.matchMenu(this.tableData)
      }
      fileReader.readAsBinaryString(files[0])
    },
    // 对数据和模块菜单进行匹配
    async matchMenu(importData) {
      const { data: res } = await this.$http.post('/Common/YKCase/excelcreate', importData)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      // 对未关联的数据进行报错提示
      const errorLength = this.setErrorIndex(importData, res.data)
      if (errorLength > 0) {
        this.$message.warning('有未关联到基础设置的数据')
      }
    },
    /**
     * 对未关联的数据进行报错提示
     * @param {Object} importData 导入时的所有数据
     * @param {Object} resData 关联得上的行数据
     */
    setErrorIndex(importData, resData) {
      // 将表格数据置空，重新赋值
      this.tableData = []

      let oldXIDMap = new Map()
      let newXIDMap = new Map()

      for (let oldItem of importData) {
        let isHas = false
        oldXIDMap.set(oldItem._XID, true)

        for (let newItem of resData) {
          if (oldItem._XID === newItem._XID) {
            // 如果id有相等，说明关联得到，追加 newItem，标记并退出
            this.tableData.push(newItem)
            isHas = true
            newXIDMap.set(newItem._XID, true)
            break
          }
        }

        // 如果标记为false，说明未关联得到，则追加 oldItem
        if (!isHas) {
          this.tableData.push(oldItem)
        }
      }

      oldXIDMap.forEach((value, key) => {
        if (!newXIDMap.has(key)) {
          const XID = key
          this.errIndex.push({
            _XID: XID,
            ifRepeat: true,
            columnIndex: 0
          })
        }
      })
      return this.errIndex.length
    },
    // 确认值
    async handleSave() {
      const that = this
      this.validEnter().then(async result => {
        if (result) {
          let tableData = [...that.tableData]
          tableData = that.removeArrayNull(tableData)
          that.$emit('sureImportBack', tableData)
          that.$nextTick(() => {
            that.isShow = false
          })
        }
      })
    },
    // cell激活控制
    // params: { column, columnIndex }
    activeMethod() {
      return true
    },
    // cell编辑控制
    // { row, rowIndex, column, columnIndex, cell }
    editMethod() {
      return true
    },
    // 单元格设置样式,错误提示
    // { row, rowIndex, column, columnIndex }
    cellClassName({ row, columnIndex }) {
      var a = this.errIndex.find(item => {
        return item._XID === row._XID && item.columnIndex === columnIndex
      })
      if (a) {
        return 'cell-valid'
      }
    },
    // 导出模板
    exportModule() {
      this.$refs.xTable.exportData({
        type: 'xlsx',
        // 过滤序号列
        columnFilterMethod: ({ column }) => {
          if (column.type === 'seq' || column.property === 'delete') {
            return false
          }
          return true
        }
      })
    },
    validRepeat(errIndex, table) {
      let isRepeat = false
      let repeatRowIndex = -1
      const tableData = table.getTableData().fullData
      // 用于存放不重复行的数据，拼接的字符串值作为 key，行索引作为 value
      const mapObj = new Map()

      // 重复行 | 分标编号、货物类别、包号、项目单位、投标人名称
      for (let [oldRowIndex, item] of tableData.entries()) {
        let cachekey =
          (item.subjectNum ? item.subjectNum : '') +
          '|' +
          (item.goodsType ? item.goodsType : '') +
          '|' +
          (item.package ? item.package : '') +
          '|' +
          (item.projectOwner ? item.projectOwner : '') +
          '|' +
          (item.bidder ? item.bidder : '')
        cachekey === '' && (cachekey = 'null')

        // 没有重复行，则将当前行数据添加进 map
        if (!mapObj.has(cachekey)) {
          mapObj.set(cachekey, oldRowIndex)
          continue
        }

        // 有重复行
        repeatRowIndex = mapObj.get(cachekey)
        item.ifRepeat = true
        item.repeatText = `与第${repeatRowIndex + 1}行数据重复`
        if (repeatRowIndex >= 0) {
          errIndex.push({
            _XID: item._XID,
            columnIndex: 0,
            repeatRowIndex: repeatRowIndex
          })
        }
        isRepeat = true
      }
      return isRepeat
    },

    // 前端不能与技术测试、业务测试相同
    validatePersonFront({ cellValue, row }) {
      return new Promise((resolve, reject) => {
        if (cellValue === '' || cellValue === '/' || cellValue == null) {
          resolve()
        } else if (row['frontEngineer'] === row['techTester'] || row['frontEngineer'] === row['businessTester']) {
          reject(new Error('研发不能同时作为测试人员'))
        } else {
          resolve()
        }
      })
    },
    // 后端不能与技术测试、业务测试相同
    validatePersonBack({ cellValue, row }) {
      return new Promise((resolve, reject) => {
        if (cellValue === '' || cellValue === '/' || cellValue == null) {
          resolve()
        } else if (row['backEngineer'] === row['techTester'] || row['backEngineer'] === row['businessTester']) {
          reject(new Error('研发不能同时作为测试人员'))
        } else {
          resolve()
        }
      })
    },
    // 技术测试不能与前端研发、后端研发相同
    validatePersonTech({ cellValue, row }) {
      return new Promise((resolve, reject) => {
        if (cellValue === '' || cellValue === '/' || cellValue == null) {
          resolve()
        } else if (row['techTester'] === row['backEngineer'] || row['techTester'] === row['frontEngineer']) {
          reject(new Error('测试不能同时作为研发人员'))
        } else {
          resolve()
        }
      })
    },
    // 业务测试不能与前端研发、后端研发相同
    validatePersonBus({ cellValue, row }) {
      return new Promise((resolve, reject) => {
        if (cellValue === '' || cellValue === '/' || cellValue == null) {
          resolve()
        } else if (row['businessTester'] === row['backEngineer'] || row['businessTester'] === row['frontEngineer']) {
          reject(new Error('测试不能同时作为研发人员'))
        } else {
          resolve()
        }
      })
    }
  },
  computed: {
    tableHeight() {
      if (this.isShow) {
        return this.$store.state.clientHeight * 0.8 - 170 + 'px'
      } else {
        return '100px'
      }
    },
    // 当前选中的版本
    productType() {
      return this.$store.state.productType
    }
  }
}
</script>

<style lang="less" scoped>
.path-box {
  width: 50%;
  margin-right: 20px;
}
.vxe-toolbar {
  display: flex;
  align-items: flex-start;
  height: 90px;
}

// 验证的红色提示框，字多会换行
/deep/ .vxe-cell--valid {
  width: 320px !important;
}
</style>
